<div class="top-header-wrapper bg-18466D d-flex flex-wrap align-items-center">
  <div class="ml-auto d-flex flex-wrap align-items-center">
    <div class="d-flex flex-wrap align-items-center gp-4">
      @if(userDetails?.appEnvironment > 0){
      <p *ngxPermissionsOnly="[UserAccess.superAdmin, UserAccess.nzmbStaff]"
        class="user-role text-ellipsis lh-18 status"
        [ngClass]="getEnvironmentName(userDetails?.appEnvironment).className">
        {{getEnvironmentName(userDetails?.appEnvironment).name}}
      </p>
      }
      @if(userDetails?.appMode == 1){
      <p *ngxPermissionsOnly="[UserAccess.superAdmin, UserAccess.nzmbStaff]"
        class="user-role f-12-400 text-FFFFFF text-ellipsis lh-18">
        {{userDetails?.appMode == 1 ? 'Development Mode' : 'Production Mode'}}
      </p>
      }
      <div *ngxPermissionsOnly="[UserAccess.exporter]" class="f-16-600 text-FFFFFF d-flex gp-4 align-items-center">
        @if(userDetails?.associatedOrganisations?.length > 1){
        <svg (click)="onSwitchOrganization()" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9.6" stroke="#fff" stroke-width="1.5"></circle>
          <path d="M7.2 9.6H16.8" stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
          <path d="M15 7.8L16.8 9.6L15 11.4" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M16.8 14.4H7.2" stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
          <path d="M9 12.6L7.2 14.4L9 16.2" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>}
        {{userDetails?.organisationName}}
      </div>
      <!-- <span class="head-noti d-flex flex-wrap align-items-center justify-content-center">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z"
            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <span class="count"></span>
      </span> -->
      <div class="user-login-wrapper d-flex flex-wrap align-items-center gp-2 position-relative cursor-pointer"
        (click)="toggleProfileDropdown($event)">
        <span class="user-profile">
          <div
            class="justify-content-center align-items-center d-flex bg-C3D9FA text-18466D f-16-600 lh-24 text-uppercase w-100">
            {{commonUtility.getInitials(userDetails?.firstName + ' ' + userDetails?.lastName)}}
          </div>
        </span>

        <div class="user-details-wrap">
          <p class="user-name f-14-600 text-FFFFFF text-ellipsis lh-20">
            {{userDetails?.firstName}} {{userDetails?.lastName}}
          </p>
          <p class="user-role f-12-400 text-FFFFFF text-ellipsis lh-18">
            {{userDetails?.userTypeName}}
          </p>
        </div>
        <span class="d-flex p-2 drop-btn" [ngClass]="{ open: showProfileDropdown }">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
        @if(showProfileDropdown){
        <div class="header-dropdown border border-d5d7da border-radius-6 overflow-hidden shadow-md w-240px">
          <div class="d-flex flex-wrap align-items-center f-14-600 text-535862 px-5 py-4 gp-3 cursor-pointer"
            (click)="viewProfile()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.6668 17.5C16.6668 16.337 16.6668 15.7555 16.5233 15.2824C16.2001 14.217 15.3664 13.3834 14.3011 13.0602C13.828 12.9167 13.2465 12.9167 12.0835 12.9167H7.91683C6.75386 12.9167 6.17237 12.9167 5.69921 13.0602C4.63388 13.3834 3.8002 14.217 3.47703 15.2824C3.3335 15.7555 3.3335 16.337 3.3335 17.5M13.7502 6.25C13.7502 8.32107 12.0712 10 10.0002 10C7.92909 10 6.25016 8.32107 6.25016 6.25C6.25016 4.17893 7.92909 2.5 10.0002 2.5C12.0712 2.5 13.7502 4.17893 13.7502 6.25Z"
                stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            View Profile
          </div>
          @if(!userDetails?.isSpecialDomain){
          <div class="d-flex flex-wrap align-items-center f-14-600 text-535862 px-5 py-4 gp-3 cursor-pointer"
            (click)="changePassword()">
            <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.5833 6.58333V4.91667C11.5833 2.61548 9.71785 0.75 7.41667 0.75C5.11548 0.75 3.25 2.61548 3.25 4.91667V6.58333M7.41667 10.3333V12M4.75 15.75H10.0833C11.4835 15.75 12.1835 15.75 12.7183 15.4775C13.1887 15.2378 13.5712 14.8554 13.8108 14.385C14.0833 13.8502 14.0833 13.1501 14.0833 11.75V10.5833C14.0833 9.1832 14.0833 8.48314 13.8108 7.94836C13.5712 7.47795 13.1887 7.0955 12.7183 6.85582C12.1835 6.58333 11.4835 6.58333 10.0833 6.58333H4.75C3.34987 6.58333 2.6498 6.58333 2.11502 6.85582C1.64462 7.0955 1.26217 7.47795 1.02248 7.94836C0.75 8.48314 0.75 9.1832 0.75 10.5833V11.75C0.75 13.1501 0.75 13.8502 1.02248 14.385C1.26217 14.8554 1.64462 15.2378 2.11502 15.4775C2.6498 15.75 3.34987 15.75 4.75 15.75Z"
                stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Reset Password
          </div>
          }

          <div *ngxPermissionsOnly="[UserAccess.exporter]" (click)="onOrganisation()"
            class="d-flex flex-wrap align-items-center f-14-600 text-535862 px-5 py-4 gp-3 cursor-pointer">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.16602 9.16667H5.16602C4.23259 9.16667 3.76588 9.16667 3.40936 9.34832C3.09576 9.50811 2.84079 9.76308 2.681 10.0767C2.49935 10.4332 2.49935 10.8999 2.49935 11.8333V17.5M17.4993 17.5V5.16667C17.4993 4.23325 17.4993 3.76654 17.3177 3.41002C17.1579 3.09641 16.9029 2.84144 16.5893 2.68166C16.2328 2.5 15.7661 2.5 14.8327 2.5H11.8327C10.8993 2.5 10.4326 2.5 10.076 2.68166C9.76243 2.84144 9.50746 3.09641 9.34767 3.41002C9.16602 3.76654 9.16602 4.23325 9.16602 5.16667V17.5M18.3327 17.5H1.66602M12.0827 5.83333H14.5827M12.0827 9.16667H14.5827M12.0827 12.5H14.5827"
                stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Organisation
          </div>
          @if(userDetails?.associatedOrganisations?.length > 1){
          <div *ngxPermissionsOnly="[UserAccess.exporter]" (click)="onSwitchOrganization()"
            class="d-flex flex-wrap align-items-center f-14-600 text-535862 px-5 py-4 gp-3 cursor-pointer">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="8" stroke="#717680" stroke-width="1.5"></circle>
              <path d="M6 8H14" stroke="#717680" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M12.5 6.5L14 8L12.5 9.5" stroke="#717680" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
              <path d="M14 12H6" stroke="#717680" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M7.5 10.5L6 12L7.5 13.5" stroke="#717680" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
            Switch Organisation
          </div>
          }
          <div (click)="logout()" class="px-5 py-4 d-flex flex-wrap align-items-center gp-3 bg-error cursor-pointer">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M7.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H7.5"
                stroke="#D92D20" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <p class="f-14-600 text-danger">Sign out</p>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>